export class Debouncer<T extends (...args: any[]) => void> {
  private timeout: NodeJS.Timeout | null = null;
  private readonly callback: T;
  private readonly delay: number;

  constructor(callback: T, delay: number) {
    this.callback = callback;
    this.delay = delay;
  }

  run = (...args: Parameters<T>) => {
    if (this.timeout) clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.callback(...args);
    }, this.delay);
  };

  cancel = () => {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = null;
  };
}
